import React, { useCallback } from "react";
import PropTypes from "prop-types";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextValidator } from "react-material-ui-form-validator";
// import { useTheme } from '@material-ui/styles'
// import { useMediaQuery } from '@material-ui/core'

const SearchDropdown = ({
	id,
	defaultOptions = [],
	disabled,
	label,
	value,
	onChange,
	props,
	readOnly = false
}) => {
	// const theme = useTheme()
	// const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
	// const [options, setOptions] = useState(defaultOptions)

	const onSelect = useCallback(
		(_, input) => {
			if (onChange && input) {
				onChange(input.value);
			} else {
				onChange("");
			}
		},
		[onChange]
	);

	// const onCreateOptions = useCallback(async (input) => {
	//   setOptions(defaultOptions)
	// }, [setOptions, defaultOptions])

	// const onInputChange = useCallback(({ target }) => {
	//   const input = target.value || ''

	//   if (input.length > 0) {
	//       onCreateOptions(input)
	//   }
	//   else {
	//     // setOptions([])
	//   }
	// }, [setOptions, onCreateOptions])

	return (
		<div>
			<Autocomplete
				id={id || "search_dropdown"}
				options={defaultOptions}
				disabled={disabled}
				onChange={onSelect}
				getOptionLabel={(option) => option && option.label}
				value={(defaultOptions && defaultOptions.find((o) => o.value === value)) || ""}
				renderInput={(params) => {
					// Autocomplete shows the option label via inputProps. The form
					// validator reads the TextField value, so the selected id has to
					// be passed here or a filled field fails "required".
					const selectedValue = value || "";
					if (readOnly) {
						return (
							<TextValidator
								{...props}
								{...params}
								label={label}
								variant="outlined"
								value={selectedValue}
								InputProps={{ ...params.InputProps, readOnly: true }}
							/>
						);
					}
					return (
						<TextValidator
							{...props}
							{...params}
							label={label}
							variant="outlined"
							value={selectedValue}
						/>
					);
				}}
			/>
		</div>
	);
};

SearchDropdown.propTypes = {
	id: PropTypes.string,
	defaultOptions: PropTypes.array,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	value: PropTypes.string,
	label: PropTypes.string
};

export default SearchDropdown;
